import { useExperienceMode } from "../../hooks/useExperienceMode"
import { ExperienceModeMenuView } from "./ExperienceModeMenuView"
import type { IProps } from "./interfaces"

/**
 * Experience-mode picker for the user dropdown. Smart: it persists the choice
 * to the user's account (so it follows them across devices) and refreshes the
 * Better Auth session so chrome (Ask AI, Credits, Jargon) catches up.
 * Mirrors LexThemeMenu's mutation + optimistic local-state pattern. Renders
 * a nested Menu.Sub so it slots into the existing user Menu.Dropdown.
 */
export const ExperienceModeMenu = ({ current }: IProps): React.JSX.Element => {
  const mode = useExperienceMode(current)
  return <ExperienceModeMenuView current={mode.current} onSelect={mode.setMode} />
}
